<!--
输入字段

使用说明：

<XInput
 :type="类型，可选text/number"
 :label="'字段名'"
 :value="'初始化数值'"
 :placeholder="'提示文本'"
 />

-->

<template>
    <div class="xinput-wrap">
        <template v-if="type == 'text'">
            <!-- 文本输入框 -->
            <div class="label" @click="onPlaceholderClick">
                {{label}}
            </div>
            <input type="text" v-model="val" @input="onInput" @focus="onFocus" @blur="onBlur" ref="input">
            <span class="placeholder" v-if="isPlaceholderShow && !val" @click="onPlaceholderClick">{{placeholder}}</span>
        </template>
        <template v-if="type == 'custom'">
            <!-- 自定义输入区域 -->
            <div class="label">
                {{label}}
            </div>
            <slot></slot>
        </template>
    </div>
</template>

<script>
export default {
  props: ['label','type','value', 'placeholder'],
  data () {
      return {
          isPlaceholderShow: true,
          val: this.value
      }
  },
  watch: {
      value (newVal, objVal) {
          this.val = newVal
      }
  },
  methods: {
      onInput () {
          this.$emit('change', this.val)
      },
      onFocus(){
        //隐藏placeholder
        this.isPlaceholderShow = false;
      },
      onBlur(){
        //显示placeholder
        this.isPlaceholderShow = true;
        //修复iOS12键盘弹出后页面底部出现空白
        window.scrollTo(0,0);
      },
      onPlaceholderClick(){
        //input获得焦点
        this.$refs.input.focus();
        this.onFocus();
      }
  }
}
</script>

<style lang="less" scoped>

.xinput-wrap{
    font-size: 3.733vw;
    line-height: 13.33vw;
    text-align: left;
    border-bottom: 1px solid #ccc;
    position: relative;
	z-index: 1;
	align-items: center;
    .label{
        display: inline-block;
        color:#666;
        width: 25.666vw;
    }

    input{
        background: transparent;
        display: inline-block;
        width: 60vw;
		color: #333333;
		height: 4vw;
		line-height: 0;
    }

    .placeholder{
        position: absolute;
        z-index: 2;
        left: 30.66vw;
        display: inline-block;
        line-height: 13.33vw;
        color: #999;
    }
}


</style>





// WEBPACK FOOTER //
// src/components/common/XInput.vue